(() => {
  'use strict';

  const focusPending = () => {
    // Shopify renders this region only after a successful customer-form post.
    // It asks for email confirmation; it does not establish consent or a reward.
    const pending = document.querySelector('#AtelierpostSignup-ks-newsletter-landing [data-ks-newsletter-pending]');
    if (!pending) return;
    pending.focus({ preventScroll: true });
    pending.scrollIntoView({ block: 'start', behavior: 'auto' });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', focusPending, { once: true });
  } else {
    focusPending();
  }
})();
